<sm-title-bar pageTitle="Bill discount" [backWithParams]="true" [headerCustomTemplate]="addButton"> 
  <ng-template #addButton>
    <div class="create_btn_sd" *ngIf="toShowCheck === 1">
      <button  mat-icon-button aria-label="option menu"  color="accent" (click)="openconfigureDiscount()" >
        <mat-icon>settings</mat-icon> 

     </button>
  </div>
  </ng-template>

</sm-title-bar>

<div class="merchant_detail_sec" >
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-12">
        <div class="drt_head">
        </div>
        <div class="list_user" *ngIf="loader == false">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Discounts status</span> 
                  <mat-slide-toggle class="share" (change)="onToggleChange($event)" [checked]="toShowCheck === 1"></mat-slide-toggle>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 14px;
                  font-size: 14px;"  *ngIf="toShowCheck === 0">{{ 'discounts.h2_disabled' | translate }}</h2>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 8px;
                  font-size: 14px;" *ngIf="toShowCheck === 1">{{ 'discounts.h2_enabled' | translate }}</h2>
                  <h4 style="margin-bottom: 20px;">Woo your customer by giving them discount on overall bill. On shop, home or virtual services. Enable and configure it based on your choice. It can be a whole amount or percentage discount on billing amount. Offering bill discounts shows customers that a business is willing to invest in the relationship by providing them with favorable financial terms. This fosters trust, which can lead to long-term customer loyalty.
                  </h4>
                </div>
              </div>
              <!-- <div class="create_btn_sd" *ngIf="toShowCheck === 1">
                <button mat-button aria-label="option menu"  color="accent" (click)="openconfigureDiscount()" >
                   Configure discount
                </button>
            </div> -->
            </div>

            <!-- <div class="card_body cbody" 
            *ngIf="toShowCheck === 1 && (discountData[0].discountType || discountData[0].discountAmount || discountData[0].minBillAmount || discountData[0].discountType || discountData[0].start_date || discountData[0].end_date || discountData[0].otherDiscounts)">
              <h2>{{ 'discounts.h3' | translate }}</h2>
              <br/>
               <div class="row">
                <div class="col-md-4" *ngIf="discountData[0].discountType && discountData[0].discountType != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.d_type' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].discountType == 1 ? 'Percentage' : 'Whole Amount'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].discountAmount != null && discountData[0].discountAmount != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.d_amount' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].discountAmount}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].minBillAmount != null && discountData[0].minBillAmount != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.min_bill_amount' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].minBillAmount}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].discountType == 1">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>

                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.max_discount_amount' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].maxDiscount}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].start_date && discountData[0].start_date != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          segment
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.start_date' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].start_date | date}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].end_date && discountData[0].end_date != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.end_date' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].end_date | date}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="discountData[0].otherDiscounts != null && discountData[0].otherDiscounts != 'null'">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> segment </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'discounts.other_d' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{discountData[0].otherDiscounts == 1 ? 'Applicable' : 'Not Applicable'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div> 

            </div> -->

            <!-- <div style="background: #f5f5f5;" *ngIf="toShowCheck === 1" (click)="configureDiscount()">
              <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;">
                <div class="book_text" >
                    <div class="entry_sec">
                        <mat-icon style="color:#222">navigate_next</mat-icon>
                    </div>
                    <p style="color:black">{{ 'discounts.btn_txt' | translate }}</p>
                </div>
            </div>
            </div>             -->
          </a>


   <!-- New design start -->
   <div class="service_info" *ngIf="toShowCheck === 1 && !loader && (discountData[0].discountType || discountData[0].discountAmount || discountData[0].minBillAmount || discountData[0].discountType || discountData[0].start_date || discountData[0].end_date || discountData[0].otherDiscounts)">
    <div class="row">
        <div class="col-sm-12">
            <div class="serv_seingo">
                <h3>Discount details</h3>
            </div>
        </div>
        <div class="col-sm-4" *ngIf="discountData[0].discountType && discountData[0].discountType != 'null'">
        <div class="service_listh">
            <div class="bus_icon">
               <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512.003 512.003" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M477.958 262.633a15.004 15.004 0 0 1 0-13.263l19.096-39.065c10.632-21.751 2.208-47.676-19.178-59.023l-38.41-20.38a15.005 15.005 0 0 1-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053 6.09a15.004 15.004 0 0 1-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061 0L193.72 42.859a15.01 15.01 0 0 1-12.613 4.099l-43.053-6.09c-23.975-3.393-46.025 12.633-50.208 36.479l-7.512 42.827a15.008 15.008 0 0 1-7.795 10.73l-38.41 20.38c-21.386 11.346-29.81 37.273-19.178 59.024l19.095 39.064a15.004 15.004 0 0 1 0 13.263L14.95 301.699c-10.632 21.751-2.208 47.676 19.178 59.023l38.41 20.38a15.005 15.005 0 0 1 7.796 10.729l7.512 42.829c3.808 21.708 22.422 36.932 43.815 36.93 2.107 0 4.245-.148 6.394-.452l43.053-6.09a15 15 0 0 1 12.613 4.099l31.251 30.232c8.702 8.418 19.864 12.626 31.03 12.625 11.163-.001 22.332-4.209 31.03-12.625l31.252-30.232c3.372-3.261 7.968-4.751 12.613-4.099l43.053 6.09c23.978 3.392 46.025-12.633 50.208-36.479l7.513-42.827a15.008 15.008 0 0 1 7.795-10.73l38.41-20.38c21.386-11.346 29.81-37.273 19.178-59.024l-19.096-39.065zM196.941 123.116c29.852 0 54.139 24.287 54.139 54.139s-24.287 54.139-54.139 54.139-54.139-24.287-54.139-54.139 24.287-54.139 54.139-54.139zm-27.944 240.77c-2.883 2.883-6.662 4.325-10.44 4.325s-7.558-1.441-10.44-4.325c-5.766-5.766-5.766-15.115 0-20.881l194.889-194.889c5.765-5.766 15.115-5.766 20.881 0s5.766 15.115 0 20.881l-194.89 194.889zm146.064 25.002c-29.852 0-54.139-24.287-54.139-54.139s24.287-54.139 54.139-54.139c29.852 0 54.139 24.287 54.139 54.139s-24.287 54.139-54.139 54.139z" fill="#262626" opacity="1" data-original="#000000" class=""></path><path d="M315.061 310.141c-13.569 0-24.609 11.039-24.609 24.608s11.039 24.608 24.609 24.608c13.569 0 24.608-11.039 24.608-24.608s-11.039-24.608-24.608-24.608zM196.941 152.646c-13.569 0-24.608 11.039-24.608 24.608s11.039 24.609 24.608 24.609 24.609-11.039 24.609-24.609c-.001-13.568-11.04-24.608-24.609-24.608z" fill="#262626" opacity="1" data-original="#000000" class=""></path></g></svg>
            </div>
            <div class="bus_hjk">
                <h4> Discount Type </h4>
                <p> {{discountData[0].discountType == 1 ? 'Percentage' : 'Whole Amount'}} </p>
                 <!-- <mat-chip-list>
                  <mat-chip>
                    <p>Whole Amount</p>
                  </mat-chip>
                </mat-chip-list> -->

            </div>
        </div>
    </div>
    <div class="col-sm-4" *ngIf="discountData[0].discountAmount != null && discountData[0].discountAmount != 'null' && discountData[0].discountType != 0">
        <div class="service_listh">
            <div class="bus_icon">
                <mat-icon>payments</mat-icon>
            </div>
            <div class="bus_hjk">
                <h4> Discount Value</h4>
                <p *ngIf="discountData[0].discountType == 1">{{discountData[0].discountAmount}}%</p>
                <p *ngIf="discountData[0].discountType == 2">{{discountData[0].currency_symbol}}{{discountData[0].discountAmount.toFixed(2)}}</p>
            </div>
        </div>
    </div>
    <div class="col-sm-4" *ngIf="discountData[0].minBillAmount != null && discountData[0].minBillAmount != 'null'">
        <div class="service_listh" style="border-right: none !important;"> 
            <div class="bus_icon">
                <mat-icon>payments</mat-icon>
            </div>
            <div class="bus_hjk">
                <h4> Minimum Bill Amount </h4>
                <p>{{discountData[0].currency_symbol}}{{discountData[0].minBillAmount.toFixed(2)}}</p>
            </div>
        </div>
    </div>
    
    <hr class="discoutnt_vv">

    <div class="col-sm-4" *ngIf="discountData[0].start_date && discountData[0].start_date != 'null'">
      <div class="service_listh">
          <div class="bus_icon">
              <mat-icon>calendar_month</mat-icon>
          </div>
          <div class="bus_hjk">
              <h4>Start Date  </h4>
              <p>{{discountData[0].start_date | date}}  </p>
          </div>
      </div>
  </div>


  <div class="col-sm-4" *ngIf="discountData[0].end_date && discountData[0].end_date != 'null'">
    <div class="service_listh">
        <div class="bus_icon">
            <mat-icon>calendar_month</mat-icon>
        </div>
        <div class="bus_hjk">
            <h4>End Date  </h4>
            <p>{{discountData[0].end_date | date}}  </p>
        </div>
    </div>
</div>

<div class="col-sm-4" *ngIf="discountData[0].otherDiscounts != null && discountData[0].otherDiscounts != 'null'">
  <div class="service_listh" style="border-right: none !important;">
      <div class="bus_icon">
          <mat-icon>list</mat-icon>
      </div>
      <div class="bus_hjk">
          <h4> Other Discount  </h4>
          <p>{{discountData[0].otherDiscounts == 1 ? 'Applicable' : 'Not Applicable'}} </p>
      </div>
  </div>
</div>
    </div>
   </div>
    <!-- New design end -->
        </div>
      </div>
      <!-- <div class="col-sm-1"></div> -->
    </div>
  </div>
</div>
